import { Suspense } from "react";
import { Link, Slot, useGlobalSearchParams } from "expo-router";
import { Chips } from "@ptsd/uikit";
import { View, XStack } from "tamagui";

import { api } from "~/utils/api";
import { LoadingScreen } from "~/components/blocks";
import { MainPageWrapper } from "~/components/layout/layout";

const Layout = () => {
  const { groupId } = useGlobalSearchParams<{
    groupId: string;
  }>();

  const [data] = api.group.getGroupNameAndStatusById.useSuspenseQuery({
    groupId,
  });

  return (
    <View>
      <MainPageWrapper
        subheader={
          groupId === "organization" ? null : (
            <XStack
              paddingTop={"$3"}
              width={"100%"}
              alignSelf="center"
              maxWidth={1248}
              paddingHorizontal={"$3"}
              alignItems="center"
              gap={"$1"}
            >
              <Link href={`/groups`}>
                <Chips.Chip
                  cursor="pointer"
                  selected={groupId === undefined}
                  backgroundColor="#0B564C"
                >
                  Групи
                </Chips.Chip>
              </Link>
              <Link href={`/groups/management/${groupId}`}>
                <Chips.Chip
                  cursor="pointer"
                  selected={groupId !== undefined}
                  backgroundColor="#0B564C"
                >
                  {data[0]?.name}
                </Chips.Chip>
              </Link>
            </XStack>
          )
        }
      >
        <Suspense fallback={<LoadingScreen height={"100dvh"} width={"100%"} />}>
          <Slot />
        </Suspense>
      </MainPageWrapper>
    </View>
  );
};
export default Layout;
